module.exports = __webpack_public_path__ + "img/download_star_more@2x.499df8d9.png";